module.exports = __webpack_public_path__ + "fonts/Font1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/reusableComponents/AutoGenerateSignature/fonts/Font1.ttf
// module id = 1730
// module chunks = 0